import { useRef } from 'react';

// Modified version of shallowEqual from https://github.com/reduxjs/react-redux/blob/master/src/utils/shallowEqual.ts
// to handle arrays as well.
const shallowEqual = (a: any, b: any) => {
    if (Object.is(a, b)) {
        return true;
    }
    if (typeof a !== 'object' || typeof b !== 'object' || !a || !b) {
        return false;
    }
    if (Array.isArray(a) !== Array.isArray(b)) {
        return false;
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) {
            return false;
        }
        for (let i = 0; i < a.length; i++) {
            if (!Object.is(a[i], b[i])) {
                return false;
            }
        }
        return true;
    }
    const ka = Object.keys(a);
    const kb = Object.keys(b);
    if (ka.length !== kb.length) {
        return false;
    }
    for (const k of ka) {
        if (!Object.is(a[k], b[k])) {
            return false;
        }
    }
    return true;
};

export const useShallowStable = <T>(value: T): T => {
    const ref = useRef<T>(value);
    if (!shallowEqual(ref.current, value)) {
        ref.current = value;
    }
    return ref.current;
};
